import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ErrorLabel from '../../../components/ErrorLabel/ErrorLabel';
import css from './CreateNewLeads.module.scss';
import axios from 'axios';
import { connect } from 'react-redux';
import {EMAIL_REGEX} from "../../../constants";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/dark.css";
import Script from 'react-load-script';
import _ from 'lodash';
import Modal from 'react-modal';


//  TODO: add validation banner for failed POST request
/**
 * @class
 */
const CreateNewLead = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    // The 'preferred notes' has fixed options -- so it's stored as a class field; we need to query  for the other dropdown options
    optionsPreferredNotes = [
        {label: 'Not Urgent-Appointment later', value: 'Not In Home'},
        {label: 'Urgent-Sitting with Customer now', value: 'In Home'}
    ];

    // ---------- state: ----------
    state = {
        optionsLeadPurpose: [],
        optionsRateChange: [],
        optionsInterestRate: [],
        optionsPreferredFinancier: [],
        optionsPreferredType: [],
        optionsPreferredFullDeal: [],
        optionsPreferredEscalator: [],
        prelimAppointmentTime: '',
        addressAutocomplete: [],
        optionsUtilityProvider: [],
        street: '',
        city: '',
        state: '',
        zip: '',
        isModalOpen: false,
        disableButton: false
    }

    // ---------- life cycle methods: ----------
    componentDidMount() {
        // We need to fetch data for dropdown options:
        axios.get(
            '/sf/lead/describeField/Preferred_Financier__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                //const filteredFinanciers = _.filter(res.data.picklistValues, function(o) {return o.value !== 'Goodleap'});
                this.setState({
                    optionsPreferredFinancier: res.data.picklistValues
                });
            });

        axios.get(
            '/sf/lead/describeField/Lead_Purpose__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsLeadPurpose: res.data.picklistValues
                });
            });

        axios.get(
            '/sf/lead/describeField/Rate_Change__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsRateChange: res.data.picklistValues
                });
            });

            axios.get(
                '/sf/lead/describeField/Interest_Rate__c',
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.setState({
                        optionsInterestRate: res.data.picklistValues
                    });
                });

        axios.get(
            '/sf/lead/describeField/Preferred_Type__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredType: res.data.picklistValues
                });
            });

        axios.get('/sf/lead/describeField/Full_Deal_Requested__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredFullDeal: res.data.picklistValues
                });
            });

        axios.get('/sf/lead/describeField/Utility_Provider__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsUtilityProvider: res.data.picklistValues
                });
            });

        axios.get('/sf/lead/describeField/Preferred_Escalator__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredEscalator: res.data.picklistValues
                });
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    handleScriptLoad = () => {
        // Declare Options For Autocomplete
        const options = {
            componentRestrictions: { country: ["us"] },
            fields: ["address_components", "geometry"],
            types: ["address"]
        };
    
        // Initialize Google Autocomplete
        /*global google*/ // To disable any eslint 'google not defined' errors
        this.autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('autocomplete'),
          options,
        );
    
        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components and formatted
        // address.
        this.autocomplete.setFields(['address_components', 'formatted_address']);
    
        // Fire Event when a suggested name is selected
        this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
      }
      
    handlePlaceSelect = () => {

        // Extract City From Address Object
        const addressObject = this.autocomplete.getPlace();
        const address = addressObject.address_components;
        const pullStreet = _.filter(address, ['types[0]', 'street_number']);
        const pullRoute = _.filter(address, ['types[0]', 'route']);
        const pullCity = _.filter(address, ['types[0]', 'locality']);
        const pullState = _.filter(address, ['types[0]', 'administrative_area_level_1']);
        const pullZip = _.filter(address, ['types[0]', 'postal_code']);

        // Check if address arrays are valid
        if(!_.isEmpty(pullStreet) && !_.isEmpty(pullRoute)) {
            this.setState(
                {
                    street: pullStreet[0].long_name + ' ' + pullRoute[0].long_name
                }
            );
        }
        if(!_.isEmpty(pullCity)) {
            this.setState(
                {
                    city: pullCity[0].long_name
                }
            );
        }
        if(!_.isEmpty(pullState)) {
            this.setState(
                {
                    state: pullState[0].short_name
                }
            );
        }
        if(!_.isEmpty(pullZip)) {
            this.setState(
                {
                    zip: pullZip[0].long_name
                }
            );
        }
    }

    /**
     * @method
     * @methodOf CreateNewLead
     *
     * Returns to Leads page view.
     * Notifies parent component (Leads) to no longer show "Create New Lead" page.
     */
    returnToLeadsPage = () => {
        this.props.onShouldShowNewLead(false);
    };

    render() {
        return (
            <React.Fragment>
            <Script
                url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY}&libraries=places`}
                onLoad={this.handleScriptLoad}
            />
            <Formik
                initialValues={{
                    FirstName: '',
                    LastName: '',
                    Phone: '',
                    Email: '',
                    Street: '',
                    City: '',
                    State: '',
                    PostalCode: '',
                    Lead_Purpose__c: '',
                    Preferred_Type__c: '',          // Preferred Type
                    Preferred_Financier__c: '',     // Preferred Financier
                    Preferred_Offset__c: '',        // Preferred Offset
                    Preferred_Escalator__c: '',     // Preferred Escalator
                    Full_Deal_Requested__c: '',     // Preferred Full Deal
                    Proposal_Notes__c: '',          // Proposal Notes
                    Prelim_Appointment_Time__c: '', // Preliminary Appointment Time
                    Rate_Change__c: '',
                    Interest_Rate__c: '',
                    Company: '',            // set equal to FirstName + LastName
                    Lead_Urgency__c: '',    // set equal to `Proposal_Notes__c`
                    Sales_Representative__c: this.props.user.apiId,
                    Utility_Provider__c: ''
                }}

                validate={
                    (values) => {
                        const errors = {};

                        if(this.state.street) {
                            values.Street = this.state.street;
                        }

                        if(this.state.city) {
                            values.City = this.state.city;
                        }

                        if(this.state.state) {
                            values.State = this.state.state;
                        }

                        if(this.state.zip) {
                            values.PostalCode = this.state.zip;
                        }
                        
                        if (!values.FirstName.trim()) {
                            errors.FirstName = 'First Name is Required';
                        }

                        if (!values.LastName.trim()) {
                            errors.LastName = 'Last Name is Required';
                        }

                        if (!values.Phone.trim()) {
                            errors.Phone = 'Phone Number is Required';
                        }

                        if (!values.Email.trim()) {
                            errors.Email = 'Email is Required';
                        } else if (!EMAIL_REGEX.test(values.Email)) {
                            errors.Email = 'Invalid Email Address';
                        }

                        if (values.Email.includes('v3electric')) {
                            errors.Email = 'Cannot Use V3 Email';
                        }

                        if (!values.Street.trim()) {
                            errors.Street = 'Street Address is Required';
                        }

                        if (!values.City.trim()) {
                            errors.City = 'City is Required';
                        }

                        if (!values.State.trim()) {
                            errors.State = 'State/Provence is Required';
                        }

                        if (!values.PostalCode.trim()) {
                            errors.PostalCode = 'Zip/Postal is Required';
                        }

                        if (values.Lead_Purpose__c === 'Office Proposal Generation' && !values.Proposal_Notes__c.trim()) {
                            errors.Proposal_Notes__c = 'Proposal Urgency Required';
                        }

                        if (!values.Utility_Provider__c.trim()) {
                            errors.Utility_Provider__c = 'Utility Provider Required';
                        }

                        if (values.Preferred_Offset__c !== '' && ((values.Preferred_Offset__c).length > 3 || /^[0-9]+$/.test(values.Preferred_Offset__c) === false)){
                            errors.Preferred_Offset__c = 'Invalid Offset, Please Enter 3 Digit Value';
                        }

                        // n.b. we're using state to validate due to using a custom date-picker component (where we have to manage its state):
                        if (!this.state.prelimAppointmentTime) {
                            errors.Prelim_Appointment_Time__c = 'Prelim Appointment Time is Required';
                        }

                        return errors;
                    }
                }

                onSubmit={
                    // n.b. fields are validated before `onSubmit` fires
                    (values) => {
                        this.setState({disableButton: true});
                        const payload = values;

                        // convert date-picker date to ISO date format:
                        payload.Prelim_Appointment_Time__c = this.state.prelimAppointmentTime ? new Date(this.state.prelimAppointmentTime).toISOString() : new Date().toISOString();

                        // update other properties before making POST request:
                        payload.Company = values.FirstName + ' ' + values.LastName;
                        payload.Lead_Urgency__c = values.Proposal_Notes__c;

                        // create new lead then return to previous page and fetch updated records:
                        axios.post(
                            '/sf/lead/create',
                            payload,
                            {
                                cancelToken: this.source.token
                            })
                            .then((res) => {
                                this.returnToLeadsPage();
                                this.props.createLeadOnSuccess();
                            })
                            .catch(err => {
                                console.log('(POST) Error in Create New Lead: \n', err)
                                this.setState({
                                    isModalOpen: true
                                })
                            });
                    }
                }
            >
                {/* N.b. this is a Formik Form component, not a generic html form tag: */}
                <Form>
                    {/* ----- Form controls: ----- */}
                    <div className="text-right">
                        <button className="btn btn-default" type="button" onClick={this.returnToLeadsPage}>Cancel</button>
                        <button className="btn btn-primary ml-2" type="submit" disabled={this.state.disableButton}>Create</button>
                    </div>

                    {/* ----- Form inputs: ----- */}
                    <div className="my-3">
                        <label className="d-block" htmlFor="FirstName">First Name*</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="FirstName" />
                        <ErrorMessage name="FirstName" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="LastName">Last Name*</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="LastName" />
                        <ErrorMessage name="LastName" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Phone">Phone*</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} type="Phone" name="Phone" />
                        <ErrorMessage name="Phone" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Email">Email*</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} type="Email" name="Email" />
                        <ErrorMessage name="Email" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block">Address Search Bar</label>
                    </div>
                    <div className="my-3 col-12">
                        <input id="autocomplete" class="form-control" type="text" placeholder="Enter Customer's Address"/>
                        <div className="text-sm">
                            (If a valid address is not found then please fill out the below fields manually)
                        </div>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Street">Street*</label>
                        {
                            this.state.street ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="Street" value={this.state.street}/>
                                <ErrorMessage name="Street" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="Street"/>
                                <ErrorMessage name="Street" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="City">City*</label>
                        {
                            this.state.city ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="City" value={this.state.city}/>
                                <ErrorMessage name="City" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="City"/>
                                <ErrorMessage name="City" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="State">State/Province*</label>
                        {
                            this.state.state ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="State" value={this.state.state}/>
                                <ErrorMessage name="State" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="State">
                                    <option value="" hidden disabled></option>
                                    <option value="CA">CA</option>
                                    <option value="TX">TX</option>
                                </Field>
                                <ErrorMessage name="State" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="PostalCode">Zip/Postal Code*</label>
                        {
                            this.state.zip ?
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="PostalCode" value={this.state.zip}/>
                                <ErrorMessage name="PostalCode" component={ErrorLabel} />
                            </div>
                            :
                            <div>
                                <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="PostalCode"/>
                                <ErrorMessage name="PostalCode" component={ErrorLabel} />
                            </div>
                        }
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Utility_Provider__c">Utility Provider*</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Utility_Provider__c">
                            <option value="" hidden disabled></option>
                            { this.state.optionsUtilityProvider.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                        <ErrorMessage name="Utility_Provider__c" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Lead_Purpose__c">Who is making the prelim proposal?</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Lead_Purpose__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsLeadPurpose.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Proposal_Notes__c">Proposal Urgency</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Proposal_Notes__c">
                            <option value="" hidden disabled></option>
                            { this.optionsPreferredNotes.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                        <ErrorMessage name="Proposal_Notes__c" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Type__c">Preferred Type</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Preferred_Type__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsPreferredType.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Financier__c">Preferred Financier</label>
                        <Field className={`${css.CreateNewLeads__Input} select`} as="select" name="Preferred_Financier__c">
                            <option value="" hidden disabled></option>
                            <option value="Cash">Cash</option>
                            {/* <option value="V3 Electric- In House">V3 Electric- In House</option> */}
                            <option value="Mosaic">Mosaic</option>
                            <option value="SunRun">SunRun</option>
                            <option value="Goodleap">Goodleap</option>
                            <option value="Everbright">Everbright</option>
                            <option value="LightReach">LightReach</option>
                            <option value="Enfin">Enfin</option>
                            <option value="Thrive">Thrive</option>
                            <option value="Solrite">Solrite</option>
                            {/* { this.state.optionsPreferredFinancier.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) } */}
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Offset__c">Preferred Offset</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} type="text" name="Preferred_Offset__c" />
                        <ErrorMessage name="Preferred_Offset__c" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Preferred_Escalator__c">Preferred Escalator</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Preferred_Escalator__c">
                            <option value="" hidden disabled></option>
                            { this.state.optionsPreferredEscalator.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Prelim_Appointment_Time__c">Prelim Appointment Time*</label>
                        {/* TODO: check Formik docs <https://formik.org/docs/api/field#children> to see if we can render custom components as Formik field; this would allow Formik to handle validation/state for us */}
                        <Flatpickr
                            name="Prelim_Appointment_Time__c"
                            data-enable-time
                            className="input w-100"
                            options={{
                                dateFormat: 'n/j/Y h:iK'
                            }}
                            value={this.state.prelimAppointmentTime}
                            onChange={date => this.setState({prelimAppointmentTime: date})}
                        />
                        <ErrorMessage name="Prelim_Appointment_Time__c" component={ErrorLabel} />
                    </div>
                    <div className="my-3">
                        <label className="d-block" htmlFor="Interest_Rate__c">Interest Rate</label>
                        <Field className={`${css.CreateNewLeads__Input} input`} as="select" name="Interest_Rate__c">
                            {/* N.b. we use an empty `<option>` tag to ensure  */}
                            <option value="" hidden disabled></option>
                            { this.state.optionsInterestRate.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </Field>
                    </div>

                    {/* ----- Form controls: ----- */}
                    <div className="text-right">
                        <button className="btn btn-default" type="button" onClick={this.returnToLeadsPage}>Cancel</button>
                        <button className="btn btn-primary ml-2" type="submit" disabled={this.state.disableButton}>Create</button>
                    </div>
                </Form>
            </Formik>

            <Modal
                isOpen={this.state.isModalOpen}
                className="ReactModal"
                overlayClassName="ReactModal__Overlay"
            >
                <div className="mt-3 text-center">
                    <h2>Lead Failed to Create</h2>
                    <p>This could be due to duplicate leads or incorrect customer data.<br></br>Please reach out to Sales Support for more information.</p>
                    <button className="btn btn-primary" type="button" onClick={() => this.setState({isModalOpen: false, disableButton: false})}>Continue</button>
                </div>
            </Modal>

            </React.Fragment>
        );
    }
}


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(CreateNewLead);
